const LockIcon = () => (
  <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_5657_40795)">
      <path
        d="M5.29248 0.0859375C3.84839 0.0859375 2.66748 1.26685 2.66748 2.71094V4.89844H1.35498V10.5859H9.22998V4.89844H7.91748V2.71094C7.91748 1.26685 6.73657 0.0859375 5.29248 0.0859375ZM5.29248 0.960938C6.26318 0.960938 7.04248 1.74023 7.04248 2.71094V4.89844H3.54248V2.71094C3.54248 1.74023 4.32178 0.960938 5.29248 0.960938Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_5657_40795">
        <rect width="10.5" height="10.5" fill="white" transform="translate(0.0424805 0.0859375)" />
      </clipPath>
    </defs>
  </svg>
);

export default LockIcon;
